import React from 'react';
import Grid from '@material-ui/core/Grid';
import Alert from '@material-ui/lab/Alert';
import Typography from '@material-ui/core/Typography';
import Input from 'components/form/Input';
import PhoneInput from 'components/form/PhoneInput';
import Select from 'components/form/Select';
import TIMEZONES from 'constant/timezones';
import Box from '@material-ui/core/Box';
import Button from 'components/common/Button';
import Form from 'components/form';
import { makeStyles } from '@material-ui/styles';
import useSnack from 'hooks/useSnack';
import { validatePhone } from 'utils';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';

const FormItem = Form.FormItem;
const CONTRACT_URL = `https://weadmit-static.s3.us-east-2.amazonaws.com/contracts/`;

const useStyles = makeStyles((theme) => ({
  root: {
    '& .MuiFormLabel-root': {
      color: '#333',
    },
  },
  sectionTitle: {
    paddingTop: 16,
    paddingBottom: 16,
  },
  btn: {
    paddingLeft: 50,
    paddingRight: 50,
  },
}));

const normalizeEmail = (v, prev) => {
  if (v === prev) {
    return v;
  }
  return v.toLowerCase().trim();
};

const CustomerInfoForm = ({ form, values }) => {
  const { getFieldDecorator } = form;

  return (
    <Form>
      <Box margin="auto" maxWidth={{ md: '60%' }}>
        <Typography paragraph align="center" variant="h5">
          Student Details
        </Typography>
        <Box marginTop={5}>
          <FormItem>
            {getFieldDecorator('firstName', {
              initialValue: values.firstName,
              rules: [
                {
                  required: true,
                  message: 'Please enter your first name',
                },
              ],
            })(<Input label="Student First Name" />)}
          </FormItem>
          <FormItem>
            {getFieldDecorator('lastName', {
              initialValue: values.lastName,
              rules: [
                {
                  required: true,
                  message: 'Please enter your last name',
                },
              ],
            })(<Input label="Student Last Name" />)}
          </FormItem>
          <FormItem>
            {getFieldDecorator('email', {
              initialValue: values.email,
              normalize: normalizeEmail,
              rules: [
                {
                  required: true,
                  message: 'Please enter your email address',
                },
                {
                  type: 'email',
                  message: 'Please enter a valid email',
                },
              ],
            })(
              <Input
                type="email"
                label="Student Email"
                hint="We'll create a Student account and send updates"
              />,
            )}
          </FormItem>
          <FormItem>
            {getFieldDecorator('emailConfirm', {
              initialValue: values.emailConfirm,
              normalize: normalizeEmail,
              rules: [
                {
                  required: true,
                  message: 'Please confirm your email address',
                },
                {
                  type: 'email',
                  message: 'Please enter a valid email',
                },
              ],
            })(
              <Input
                type="email"
                label="Confirm Email"
                hint="Please enter student's email address again"
              />,
            )}
          </FormItem>
          <FormItem>
            {getFieldDecorator('phone', {
              initialValue: values.phone,
              rules: [
                {
                  required: true,
                  message: 'Please enter your phone number',
                },
                {
                  validator: validatePhone,
                  skipNetwork: true,
                },
              ],
            })(
              <PhoneInput
                label="Student Mobile Number"
                hint="We will send text updates to your student’s mobile number"
              />,
            )}
          </FormItem>
          <FormItem>
            {getFieldDecorator('relationship', {
              initialValue: values.relationship,
              rules: [
                {
                  required: true,
                  message: 'Please enter relationship',
                },
              ],
            })(<Input label="What is your relationship with the student?" />)}
          </FormItem>
          <FormItem>
            {getFieldDecorator('timezone', {
              initialValue: values.timezone,
              rules: [{ required: true, message: 'Please select timezone' }],
            })(
              <Select
                noMargin
                transformValue
                isMulti={false}
                label="Student's Timezone?"
                options={TIMEZONES}
              />,
            )}
          </FormItem>
        </Box>
      </Box>
    </Form>
  );
};

export default Form.create()(CustomerInfoForm);
